import axios from 'axios'

export const USER_ROLES = {
  ADMIN: 'admin',
  READONLY: 'readonly'
}
export const AUTH_KEY = 'eci_auth'
const loginApiUrl = process.env.VUE_APP_LOGIN_URL

function buildBaseUrl (auth) {
  const { carto_user: user = '', carto_base_url: url = '' } = auth
  if (url === `https://${user}.carto.com`) {
    return url
  }
  if (url.indexOf('https') === -1 && url.indexOf('http') === -1) {
    return `https://${url}/user/${user}`
  }
  return `${url}/user/${user}`
}

export default {
  getAuth () {
    const data = JSON.parse(localStorage.getItem(AUTH_KEY) || '{}')
    return {
      role: data.role,
      apikey: data.apikey,
      api_base_url: data.api_base_url,
      username: data.username,
      display_name: data.display_name
    }
  },
  setAuth: (auth) => localStorage.setItem(AUTH_KEY, JSON.stringify(auth)),
  removeAuth: () => localStorage.removeItem(AUTH_KEY),
  async login ({ username, password }) {
    const auth = await axios.post(loginApiUrl, { username, password }).then(res => res.data)
    this.setAuth({
      role: auth.role,
      apikey: auth.carto_api_key,
      api_base_url: buildBaseUrl(auth),
      username: auth.username,
      display_name: auth.display_name
    })
  },
  logout () {
    this.removeAuth()
  },
  isLoggedIn () {
    const auth = this.getAuth()
    return auth && auth.apikey
  }
}
